<template>

<app-content-filters class="filters">

	<app-content-filters-search v-model="filter.search" />

</app-content-filters>

</template>

<script>

export default {

	props: ['filter']

}

</script>

<style scoped>

.is-mobile .filters {
	flex-wrap: wrap;
	height: auto;
}

.filters >>> .toggle {
	height: 30px;
}

.filters >>> .toggle-item {
	line-height: 28px;
	opacity: 0.25;
}

.filters >>> .toggle-item:hover {
	opacity: 1;
}

.filters >>> .toggle-item.is-active {
	background-color: #2f3a4a;
	color: #fff;
	border-color: #2f3a4a;
	opacity: 1;
}

</style>